import { DeclineProtectionEffects } from './decline.protection.effect';
import { ItemOfferEffects } from './item.offer.effect';
import { ProtectionEffects } from './protection.effect';

export const AdditionalServicesEffects = [
  ItemOfferEffects,
  ProtectionEffects,
  DeclineProtectionEffects,
];
